import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const audioPlayerAdaptor = createEntityAdapter();

export interface AudioPlayerStateType {
  loaded: boolean;
  mute: boolean;
  playing: boolean;
  source: string;
  howler?: any;
  entity?: any;
}

const initialState: AudioPlayerStateType = audioPlayerAdaptor.getInitialState({
  loaded: false,
  mute: false,
  playing: false,
  source: '',
  howler: null,
});

const audioPlayerSlice = createSlice({
  name: 'audioPlayer',
  initialState,
  reducers: {
    playPauseAudio: (state, action) => {
      state.loaded = true;
      state.entity = action.payload.entity ? action.payload.entity : '';
      state.source = action.payload.source;
      if (action.payload.source !== '') {
        if (state.howler && !state.playing) {
          state.mute = false;
          state.howler.mute(false);
        }

        state.playing = !state.playing;
      }
    },
    playAudio: (state, action) => {
      state.loaded = true;
      state.entity = action.payload.entity ? action.payload.entity : '';
      state.source = action.payload.source;
      if (action.payload.source !== '') {
        if (state.howler && !state.playing) {
          state.mute = false;
          state.howler.mute(false);
        }

        state.playing = true;
      }
    },
    stopAudio: (state) => {
      state.playing = false;
      state.source = '';
    },
    endAudio: (state) => {
      state.loaded = false;
      state.playing = false;
      state.howler = null;
      state.source = '';
    },
    loadAudio: (state, action) => {
      state.howler = action.payload;
    },
    seekAudio: (state, action) => {
      state.howler.seek(action.payload);
    },
    setAudioVolume: (state, action) => {
      state.howler.volume(action.payload);
    },
    setMute: (state, action) => {
      state.mute = action.payload;
      if (state.howler) state.howler.mute(action.payload);
    },
  },
});

export const { name, actions, reducer } = audioPlayerSlice;
